/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import StatusProxy from 'astro/server/status/proxy';

import * as Influence from 'astro/util/influence';


export default class extends StatusProxy
{
  constructor (entity)
  {
    super();

    this.entity = entity;
  }


  onInstallIdle (status)
  {
    this.installAttrition();

    this.entity.installPassiveBenefit();
  }


  onInstallSetup (status)
  {
    this.installAttrition();

    this.entity.installPassiveBenefit();
  }


  onInstallActive (status)
  {
    this.installAttrition();

    this.entity.installActiveBenefit();
  }


  onInstallCooldown (status)
  {
    this.installAttrition();

    this.entity.installPassiveBenefit();
  }


  onInstallDisband (status)
  {
    this.installAttrition();

    this.entity.installPassiveBenefit();
  }


  installAttrition ()
  {
    if (this.entity.getConstants().getAttrition() == 0)
    {
      return;
    }

    const attrition = Influence.makeAttrition(this.entity.getCass().getUser(), this.entity.getLocation(), - this.entity.getConstants().getAttrition());

    this.entity.getZone().getAttributes().installInfluence(attrition);
  }


};
